(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-contact"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('.src').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';
const form=root.querySelector('form'),
radios=[...root.querySelectorAll('[data-reason]')],
panels=[...root.querySelectorAll('[data-panel]')],
message=root.querySelector('[data-message]'),
locked=root.querySelector('[data-locked]'),
content=root.querySelector('[data-detail-content]'),
selectedLabel=root.querySelector('[data-selected-label]'),
changeBtn=root.querySelector('[data-change-topic]'),
topicCard=root.querySelector('.src__topic-card'),
STORE='srcSentSummary',
DB_STORE='srcPendingDatabaseEnquiry',
DB_URL_DEFAULT='https://jmqghheucwrmdfabujof.supabase.co',
DB_KEY_DEFAULT='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImptcWdoaGV1Y3dybWRmYWJ1am9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQyNzQ4NDQsImV4cCI6MjA5OTg1MDg0NH0.2QtHE2Z97j8rFAgKsjXCmDtcu2LX2NDsEKm_PDG6mSM';
const SENT_COPY={
order:['Your order tracking request is noted.','We’re checking where your order is.'],
wrongitem:['Your delivery problem is noted.','We’re sorry — we’ll check what went wrong and make it right.'],
cancel:['Your cancel, return or refund request is noted.','We’ll action it as quickly as possible.'],
sizing:['Your sizing request is noted.','We’ll reply with the size that fits best.'],
deadline:['Your deadline is noted.','We’ll confirm what’s realistic before you commit.'],
issue:['Your product issue is noted.','We’re sorry — we’ll make this right.'],
change:['Your change request is noted.','We’ll check if your order can still be updated.'],
other:['Your message is received.','The right person will reply soon.'],
bulk:['Your team order enquiry is noted.','Our team will follow up with options.'],
name:['Your personalisation request is noted.','Your name and flag details are recorded.'],
billing:['Your billing issue is noted.','We’ll check the payment records and sort it out.'],
promo:['Your promo code issue is noted.','We’ll check the code and get back to you.'],
presale:['Your question is noted.','We’ll answer before you order.']};
const DEFLECT={
order:{gate:true,title:'Fastest way to track',text:function(w){return 'Your shipping confirmation email has a live tracking link with up-to-the-minute status — usually faster than writing to us.'}},
deadline:{gate:true,title:'Will it arrive in time?',text:function(w){return 'Standard delivery is '+w+'. If your date is further away than that, you’re safe to order — no message needed.'}},
promo:{gate:true,title:'Quick code checks first',text:function(w){return 'Codes are case-sensitive, single-use, and don’t stack with other discounts. A re-try fixes most cases.'}},
presale:{gate:true,title:'The answer may already be there',text:function(w){return 'Size chart, materials and delivery times are on every product page.'}},
sizing:{gate:false,title:'Size chart first',text:function(w){return 'Every product page has a size chart — it answers most sizing questions in seconds.'}}
};
function applyDeflect(key,panel){
  const cfg=DEFLECT[key];
  if(!cfg){content.classList.remove('src--gated');return;}
  let box=panel.querySelector('.src-deflect');
  if(!box){
    box=document.createElement('div');box.className='src-deflect';
    const st=document.createElement('strong'),tx=document.createElement('p');
    st.textContent=cfg.title;
    tx.textContent=cfg.text(root.dataset.deliveryWindow||'7–10 business days');
    box.append(st,tx);
    if(cfg.gate){
      const btn=document.createElement('button');btn.type='button';btn.textContent='I still need help';
      btn.addEventListener('click',()=>{
        content.classList.remove('src--gated');
        box.classList.add('src-deflect--done');
        sweepValid();updateRace();
      });
      box.append(btn);
    }
    panel.prepend(box);
  }
  if(cfg.gate)box.classList.remove('src-deflect--done');
  content.classList.toggle('src--gated',!!cfg.gate);
}
function setBranch(scope){
  const sel=scope.querySelector('[data-branch]:checked');
  scope.querySelectorAll('[data-branch-panel]').forEach(bp=>{
    const active=!!sel&&bp.dataset.branchPanel===sel.dataset.branch;
    bp.hidden=!active;
    bp.querySelectorAll('input,select,textarea').forEach(field=>{
      field.disabled=!active;
      if(field.hasAttribute('data-required'))field.required=active;
    });
  });
}
function show(radio){
  const key=radio.dataset.reason;
  panels.forEach(panel=>{
    const active=panel.dataset.panel===key;
    panel.hidden=!active;
    panel.setAttribute('aria-hidden',String(!active));
    panel.querySelectorAll('input,select,textarea').forEach(field=>{
      field.disabled=!active;
      if(field.hasAttribute('data-required'))field.required=active;
    });
  });
  locked.hidden=true;
  content.hidden=false;
  selectedLabel.textContent=radio.value;
  if(message)message.placeholder=key==='cancel'?'Please tell us why you want to cancel or request a refund.':message.dataset.default;
  const activePanel=panels.find(pn=>!pn.hidden);
  if(activePanel){
    activePanel.querySelectorAll('[data-branch-root]').forEach(setBranch);
    applyDeflect(key,activePanel);
  }
  if(radio.closest('details'))radio.closest('details').open=true;
  if(matchMedia('(max-width: 1023px)').matches)content.scrollIntoView({behavior:'smooth',block:'start'});
  sweepValid();
  updateRace();
}
radios.forEach(r=>r.addEventListener('change',()=>show(r)));
root.querySelectorAll('[data-branch]').forEach(b=>b.addEventListener('change',()=>{setBranch(b.closest('[data-branch-root]'));sweepValid();updateRace()}));
panels.forEach(panel=>panel.querySelectorAll('input,select,textarea').forEach(field=>field.disabled=true));
const selected=radios.find(r=>r.checked);
if(selected)show(selected);
if(changeBtn)changeBtn.addEventListener('click',()=>topicCard.scrollIntoView({behavior:'smooth',block:'start'}));
function collectSummary(){
  const checked=radios.find(r=>r.checked);
  if(!checked)return null;
  const rows=[['Topic',checked.value]];
  const orderNo=root.querySelector('input[name="contact[Order number]"]');
  if(orderNo&&orderNo.value.trim())rows.push(['Order number',orderNo.value.trim()]);
  const active=panels.find(p=>!p.hidden);
  if(active)active.querySelectorAll('input,select,textarea').forEach(f=>{
    if(f.type==='file'||f.disabled||!f.value||!f.value.trim())return;
    if(f.type==='radio'&&!f.checked)return;
    const label=(f.name||'').replace(/^contact\[/,'').replace(/\]$/,'');
    if(label&&label!=='Order number')rows.push([label,f.value.trim()]);
  });
  if(message&&message.value.trim()){
    let body=message.value.trim();
    if(body.length>140)body=body.slice(0,140)+'…';
    rows.push(['Message',body]);
  }
  const read=sel=>{const f=root.querySelector(sel);return f&&f.value?f.value.trim():''};
  return {
    key:checked.dataset.reason,
    rows:rows,
    contact:{
      first_name:read('input[name="contact[First name]"]'),
      last_name:read('input[name="contact[Last name]"]'),
      email:read('input[name="contact[email]"]'),
      order_number:orderNo&&orderNo.value?orderNo.value.trim():'',
      message:message&&message.value?message.value.trim():''
    }
  };
}
function saveDraft(){
  const summary=collectSummary();
  if(!summary)return;
  summary.t=Date.now();
  try{localStorage.setItem(STORE,JSON.stringify(summary))}catch(e){}
}
function updateRace(){
  const raceCar=root.querySelector('[data-race-car]'),raceFill=root.querySelector('[data-race-fill]'),raceMsg=root.querySelector('[data-race-msg]'),racePct=root.querySelector('[data-race-pct]'),raceBox=root.querySelector('.src__race');
  if(!raceCar||!form)return;
  const fields=[...content.querySelectorAll('input:not([type=hidden]):not([type=file]):not([type=radio]),select,textarea')].filter(f=>!f.disabled);
  const filled=fields.filter(f=>f.value&&f.value.trim()).length;
  const p=fields.length?Math.round(filled/fields.length*100):0;
  const ready=form.checkValidity();
  raceCar.style.setProperty('--rp',p/100);
  raceFill.style.width=p+'%';
  racePct.textContent=p+'%';
  raceMsg.textContent=ready
    ?(p===100?'Perfect lap — thank you! 🏁':'Ready to send — extras are optional 🏁')
    :(p===0?'Start your engines…':p<40?'Nice start — keep rolling':p<80?'Great pace!':'Final lap!');
  raceBox.classList.toggle('src__race--done',ready);
}
function sweepValid(){
  content.querySelectorAll('input,select,textarea').forEach(f=>{
    if(f.type==='radio'||f.type==='hidden'||f.type==='file'||f.disabled)return;
    const holder=f.closest('label');
    if(!holder||holder.classList.contains('is-error'))return;
    if(f.value&&f.value.trim()&&f.checkValidity())holder.classList.add('is-valid');
    else holder.classList.remove('is-valid');
  });
}
function friendlyError(f){
  if(f.validity.valueMissing){
    if(f.type==='email')return 'We need your email so we can reply to you.';
    if(f.tagName==='TEXTAREA')return 'A quick message helps us help you — even one line is fine.';
    return 'Could you fill this one in?';
  }
  if(f.type==='email')return 'Hmm, that email doesn’t look right yet — double-check the @ and the ending.';
  if(f.validity.patternMismatch)return 'That doesn’t look like a link yet — paste the full URL, e.g. https://…';
  return 'This doesn’t look quite right yet.';
}
function inlineSendError(text){
  let note=form.querySelector('[data-send-error]');
  if(!note){
    note=document.createElement('div');
    note.className='src__errors';
    note.setAttribute('data-send-error','');
    note.setAttribute('role','alert');
    const sb=form.querySelector('.src__submit');
    sb.parentNode.insertBefore(note,sb);
  }
  note.textContent=text;
  note.scrollIntoView({behavior:'smooth',block:'center'});
}
function showFieldError(f){
  const holder=f.closest('label');
  if(!holder)return;
  holder.classList.add('is-error');
  holder.classList.remove('is-valid');
  let msg=holder.querySelector('.src-fielderr');
  if(!msg){msg=document.createElement('small');msg.className='src-fielderr';holder.appendChild(msg)}
  msg.textContent=friendlyError(f);
  let clr=holder.querySelector('.src-clear');
  if(!clr){
    clr=document.createElement('button');
    clr.setAttribute('type','button');clr.className='src-clear';
    clr.setAttribute('aria-label','Clear this field');
    clr.addEventListener('click',ev=>{
      ev.preventDefault();ev.stopPropagation();
      f.value='';refreshField(f);sweepValid();updateRace();saveDraft();f.focus();
    });
    holder.appendChild(clr);
  }
  f.classList.add('src-shake');
  setTimeout(()=>f.classList.remove('src-shake'),450);
}
function refreshField(f){
  if(!f||!f.closest||f.type==='radio'||f.type==='hidden'||f.type==='file')return;
  const holder=f.closest('label');
  if(!holder)return;
  const err=holder.querySelector('.src-fielderr');
  if(err){err.remove();holder.classList.remove('is-error')}
  const clr=holder.querySelector('.src-clear');
  if(clr)clr.remove();
  if(f.value&&f.value.trim()&&f.checkValidity())holder.classList.add('is-valid');
  else holder.classList.remove('is-valid');
}
if(form){
  form.setAttribute('novalidate','');
  form.addEventListener('input',e=>{saveDraft();refreshField(e.target);sweepValid();updateRace()});
  form.addEventListener('focusout',e=>{
    const f=e.target;
    if(f&&f.willValidate&&!f.disabled&&f.type!=='radio'&&f.value&&f.value.trim()&&!f.checkValidity())showFieldError(f);
  });
  form.addEventListener('change',e=>{saveDraft();refreshField(e.target);sweepValid();updateRace()});
  setTimeout(()=>{sweepValid();updateRace()},400);
  setTimeout(()=>{sweepValid();updateRace()},1500);
  form.addEventListener('submit',e=>{
    const invalid=[...form.querySelectorAll('input,select,textarea')].filter(f=>!f.disabled&&f.willValidate&&!f.checkValidity());
    if(invalid.length){
      e.preventDefault();
      invalid.forEach(showFieldError);
      invalid[0].focus({preventScroll:true});
      invalid[0].scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }
    const summary=collectSummary();
    saveDraft();
    if(!window.fetch||!window.FormData||!summary)return;
    e.preventDefault();
    const btn=form.querySelector('.src__submit'),label=btn?btn.querySelector('span'):null;
    if(btn){btn.disabled=true;btn.classList.add('src__submit--sending')}
    if(label){label.dataset.original=label.textContent;label.textContent='Sending…'}
    const restore=()=>{if(btn){btn.disabled=false;btn.classList.remove('src__submit--sending')}if(label&&label.dataset.original)label.textContent=label.dataset.original};
    const oldNote=form.querySelector('[data-send-error]');
    if(oldNote)oldNote.remove();
    fetch(form.getAttribute('action')||location.pathname,{method:'POST',body:new FormData(form),credentials:'same-origin'})
      .then(async res=>{
        let responseHtml='';
        try{responseHtml=await res.clone().text()}catch(err){}
        const shopifyAccepted=res.ok&&(res.url.indexOf('contact_posted=true')>-1||responseHtml.indexOf('data-posted')>-1);
        if(shopifyAccepted){
          try{localStorage.removeItem(STORE)}catch(err){}
          logToDatabase(summary).then(saved=>{
            if(!saved)setTimeout(()=>logToDatabase(summary),3000);
          });
          renderSent(summary);
        }else{
          restore();
          inlineSendError('We couldn’t send that — please double-check your email address, then press Send again. Nothing you typed was lost.');
          const em=root.querySelector('input[name="contact[email]"]');
          if(em)showFieldError(em);
        }
      })
      .catch(()=>{
        restore();
        inlineSendError('Connection hiccup — nothing you typed was lost. Please press Send again.');
      });
  });
}
async function logToDatabase(summary){
  const dbUrl=(root.dataset.dbUrl||DB_URL_DEFAULT).trim(),dbKey=(root.dataset.dbKey||DB_KEY_DEFAULT).trim();
  if(!dbUrl||!dbKey||!window.fetch||!summary){
    console.warn('[Smart contact] Database logging is not configured.');
    return false;
  }
  try{
    try{localStorage.setItem(DB_STORE,JSON.stringify({summary:summary,t:Date.now()}))}catch(err){}
    const val=sel=>{const f=root.querySelector(sel);return f&&f.value?f.value.trim():''};
    const rowmap={};summary.rows.forEach(pair=>{rowmap[pair[0]]=pair[1]});
    const stored=summary.contact||{};
    const fullName=[stored.first_name||val('input[name="contact[First name]"]'),stored.last_name||val('input[name="contact[Last name]"]')].filter(Boolean).join(' ');
    const payload={
      topic_key:summary.key,
      topic:rowmap['Topic']||summary.key,
      customer_name:fullName,
      email:stored.email||val('input[name="contact[email]"]'),
      order_number:stored.order_number||rowmap['Order number']||val('input[name="contact[Order number]"]'),
      message:stored.message||rowmap['Message']||(message&&message.value?message.value.trim():''),
      details:rowmap,
      urgent:['cancel','change','wrongitem','billing','deadline'].indexOf(summary.key)>-1
    };
    const res=await fetch(dbUrl.replace(/\/+$/,'')+'/rest/v1/enquiries',{
      method:'POST',
      keepalive:true,
      headers:{'Content-Type':'application/json','apikey':dbKey,'Authorization':'Bearer '+dbKey,'Prefer':'return=minimal'},
      body:JSON.stringify(payload)
    });
    if(!res.ok){
      let reason='HTTP '+res.status;
      try{const body=await res.text();if(body)reason+=' — '+body.slice(0,300)}catch(err){}
      throw new Error(reason);
    }
    console.info('[Smart contact] Enquiry saved to database.');
    try{localStorage.removeItem(DB_STORE)}catch(err){}
    return true;
  }catch(e){
    console.error('[Smart contact] Database insert failed:',e);
    return false;
  }
}
function renderSent(data){
  const sent=root.querySelector('[data-sent]');
  if(!sent)return;
  if(root.classList.contains('src--sent')||root.classList.contains('src--leaving'))return;
  if(!data){
    try{data=JSON.parse(localStorage.getItem(STORE))}catch(e){data=null}
    if(data&&data.t&&Date.now()-data.t>1800000)data=null;
  }
  const copy=(data&&SENT_COPY[data.key])||['Your request is received.','Our team will reply soon.'];
  sent.querySelector('[data-sent-heading]').textContent=copy[0];
  sent.querySelector('[data-sent-copy]').textContent=copy[1];
  const list=sent.querySelector('[data-sent-rows]'),note=sent.querySelector('[data-sent-note]');
  while(list.firstChild)list.firstChild.remove();
  const hasRows=!!(data&&data.rows&&data.rows.length);
  if(note)note.hidden=!hasRows;
  if(hasRows){
    list.hidden=false;
    data.rows.forEach(pair=>{
      const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');
      dt.textContent=pair[0];dd.textContent=pair[1];
      row.append(dt,dd);list.append(row);
    });
  }
  root.classList.add('src--leaving');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  setTimeout(()=>{
    const h1=root.querySelector('.src__hero h1');
    if(h1){
      if(!h1.dataset.original)h1.dataset.original=h1.innerHTML;
      h1.textContent='Request ';const em=document.createElement('em');em.textContent='received';h1.append(em);
    }
    const sub=root.querySelector('.src__subheading');
    if(sub){
      if(!sub.dataset.original)sub.dataset.original=sub.textContent;
      sub.textContent='Here’s a copy of what you sent — our team is on it.';
    }
    root.classList.add('src--sent');
    root.classList.remove('src--leaving');
    sent.hidden=false;
    requestAnimationFrame(()=>requestAnimationFrame(()=>root.classList.add('src--sent-ready')));
    try{sent.focus({preventScroll:true})}catch(e){sent.focus()}
    setTimeout(()=>root.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'}),reduced?0:80);
  },reduced?0:220);
}
function resetToForm(){
  try{localStorage.removeItem(STORE)}catch(e){}
  const sent=root.querySelector('[data-sent]');
  if(form)form.reset();
  radios.forEach(r=>r.checked=false);
  panels.forEach(panel=>{
    panel.hidden=true;
    panel.setAttribute('aria-hidden','true');
    panel.querySelectorAll('input,select,textarea').forEach(field=>field.disabled=true);
  });
  if(message)message.placeholder=message.dataset.default;
  const btn=root.querySelector('.src__submit'),label=btn?btn.querySelector('span'):null;
  if(btn){btn.disabled=false;btn.classList.remove('src__submit--sending')}
  if(label&&label.dataset.original)label.textContent=label.dataset.original;
  root.querySelectorAll('label.is-valid,label.is-error').forEach(l=>l.classList.remove('is-valid','is-error'));
  root.querySelectorAll('.src-fielderr').forEach(m=>m.remove());
  updateRace();
  locked.hidden=false;
  content.hidden=true;
  root.classList.remove('src--sent-ready');
  if(sent)sent.hidden=true;
  root.classList.remove('src--sent','src--leaving');
  content.classList.remove('src--gated');
  const h1=root.querySelector('.src__hero h1');
  if(h1&&h1.dataset.original)h1.innerHTML=h1.dataset.original;
  const sub=root.querySelector('.src__subheading');
  if(sub&&sub.dataset.original)sub.textContent=sub.dataset.original;
  if(history.replaceState)history.replaceState(null,'',location.pathname);
  topicCard.scrollIntoView({behavior:'smooth',block:'start'});
}
const again=root.querySelector('[data-send-another]');
if(again)again.addEventListener('click',resetToForm);
const nativePosted=root.querySelector('[data-posted]');
if(nativePosted){
  let postedSummary=null;
  try{postedSummary=JSON.parse(localStorage.getItem(STORE))}catch(err){}
  if(postedSummary&&postedSummary.key&&postedSummary.rows){
    logToDatabase(postedSummary).then(saved=>{
      if(!saved)setTimeout(()=>logToDatabase(postedSummary),3000);
    });
  }
  renderSent(postedSummary);
}else if(location.hash==='#src-sent')renderSent();
if(!nativePosted){
  try{
    const pending=JSON.parse(localStorage.getItem(DB_STORE));
    if(pending&&pending.summary&&pending.t&&Date.now()-pending.t<86400000)setTimeout(()=>logToDatabase(pending.summary),1200);
    else if(pending)localStorage.removeItem(DB_STORE);
  }catch(err){}
}
})})();

  } catch(e) { console.error(e); }
})();
})();
